export class Logininfo {
  username: string;
  password: string;
}

